export default __webpack_public_path__ + "static/media/debt.6ca8ce99.png";